import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/Auth/AppModule'
import CreateSubTransactionTypeRequest from '@/models/Products/SubTransactionTypes/CreateSubTransactionTypeRequest';
import SubTransactionType from '@/models/Products/SubTransactionTypes/SubTransactionType';
import PermissionUtils from '@/lib/permissionUtils';

export interface SubTransactionTypeState {
    loading: boolean;
    loadingDialog: boolean;
    subTransactionTypes: SubTransactionType[];
    totalSubTransactionTypesPages: number;
    subTransactionType: SubTransactionType;
    newTransactionTypeID: string;
    pageSize: number;
}

@Module({ dynamic: true, store, name: 'SubTransactionTypesModule', namespaced: true })
class SubTransactionTypesStore extends VuexModule implements SubTransactionTypeState {

    public loading: boolean = true;
    public loadingDialog: boolean = false;
    public subTransactionTypes: SubTransactionType[] = [];
    public totalSubTransactionTypesPages: number = 1;
    public subTransactionType: SubTransactionType = new SubTransactionType();
    public newTransactionTypeID: string = '';
    public pageSize: number = PermissionUtils.getPageSize();

    @Action
    async getSubTransactionTypes() {

        this.setLoading(true);

        await ajax.get('/portal-backend/fi-api/sub-transaction-types')
        .then(response => {
            this.context.commit("setSubTransactionTypes", response.data.results);
            this.context.commit("setSubTransactionTypesTotalPages", response.data.records.totalRecords);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async getSubTransactionType(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/sub-transaction-types/${id}`)
        .then(response => {
            this.context.commit("setSubTransactionType", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async createSubTransactionType(request: CreateSubTransactionTypeRequest) {

        this.setLoadingDialog(true);

        await ajax.post(`/portal-backend/fi-api/sub-transaction-types`, request)
        .then(response => {
            this.context.commit("setSubTransactionTypeFromCreate", response.data.id);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loading = true;
        this.loadingDialog = false;
        this.subTransactionTypes = [];
        this.totalSubTransactionTypesPages = 1;
        this.subTransactionType = new SubTransactionType();
        this.newTransactionTypeID = '';
    }

    @Mutation
    private async setLoading(loading: boolean) {
        this.loading = loading;
    }

    @Mutation
    private async setLoadingDialog(loading: boolean) {
        this.loadingDialog = loading;
    }

    @Mutation
    private async setSubTransactionTypes(response: SubTransactionType[]) {
        if (response) {
            this.subTransactionTypes = response;
        }
    }

    @Mutation
    private async setSubTransactionTypesTotalPages(total: number) {
        this.totalSubTransactionTypesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setSubTransactionType(response: SubTransactionType) {
        this.subTransactionType = response;
    }

    @Mutation
    private async setSubTransactionTypeFromCreate(id: string) {
        this.newTransactionTypeID = id;
    }

}

export const SubTransactionTypesModule = getModule(SubTransactionTypesStore)